import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType, CommonRoutes,
} from 'app/enums/common.enums'
import {
    ProductType,
    PreBookingContainerStatus,
} from 'app/enums/label.enums'
import {
    PreBookingsTableType,
} from 'app/common/PreBooking/PreBooking.types'

const preBookingsConfig: SkyNetTableConfig<keyof PreBookingsTableType> = {
    name: 'Account.PreBookings',
    tabs: [{
        name: 'Pending Pre Bookings',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'preBookingNumber',
                labelKey: 'Prebooking.number',
            },
            {
                name: 'originAirportIataCode',
                labelKey: 'OrderBaseTabView.from',
                filterField: 'originAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationAirportIataCode',
                labelKey: 'OrderBaseTabView.to',
                filterField: 'destinationAirportIataCode',
                filterType: FilterType.Array,
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'Prebooking.pricingAccount',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
            },
            {
                name: 'customerExecution',
                labelKey: 'Prebooking.customerExecution',
                filterField: 'customerExecution',
                filterType: FilterType.Array,
            },
            {
                name: 'containersStatus',
                labelKey: 'Prebooking.containerStatus',
                componentName: 'EnumValue',
                allowedValuesEnum: PreBookingContainerStatus,
                filterField: 'containersStatus',
                filterType: FilterType.Array,
            },
            {
                name: 'project',
                labelKey: 'Prebooking.project',
            },
            {
                name: 'destinationCountryName',
                labelKey: 'Prebooking.destinationCountry',
            },
            {
                name: 'requestedHandover',
                labelKey: 'Prebooking.requestedHandover',
                filterField: 'requestedHandover',
                filterType: FilterType.Array,
                componentName: 'DateTimeCell',
            },
            {
                name: 'requestedHandoverWeek',
                labelKey: 'Prebooking.requestedHandoverWeek',
            },
            {
                name: 'requiredContainers',
                componentName: 'RequiredContainersList',
                allowedValuesEnum: ProductType,
                sorting: false,
                labelKey: 'Prebooking.requiredContainers',
            },
        ],
    }],
}

export default preBookingsConfig
